'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/** START: Query */

/** END: Query */

/** START: Requests */

/** END: Requests */

/** START: Responses */

/** END: Responses */

/** START: Responses */
var HealthPointApplicationStatus = /*#__PURE__*/function (HealthPointApplicationStatus) {
  HealthPointApplicationStatus["APPROVED"] = "approved";
  HealthPointApplicationStatus["SUBMITTED"] = "submitted";
  HealthPointApplicationStatus["REJECTED"] = "rejected";
  return HealthPointApplicationStatus;
}({});
/** END: Requests */

exports.HealthPointApplicationStatus = HealthPointApplicationStatus;
